import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  uploadItemValidate,
  upload,
  getExport,
  getDetailAll,
  createUomPrice,
} from "./pricelistAPI";

const initialState = {
  data: [],
  data2: [],
  data3: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "pricelist/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchDetailPrices = createAsyncThunk(
  "pricelist/fetchDetailPrices",
  async (payload) => {
    const response = await getDetailAll(payload);
    return response;
  }
);
export const fetchDataType = createAsyncThunk(
  "pricelist/fetchDataType",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("pricelist/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "pricelist/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "pricelist/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const addUomPrice = createAsyncThunk(
  "pricelist/addUomPrice",
  async (payload) => {
    const response = await createUomPrice(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "pricelist/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "pricelist/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "pricelist/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "pricelist/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "pricelist/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const pricelistSlice = createSlice({
  name: "pricelist",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchDataType.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchDataType.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchDetailPrices.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchDetailPrices.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUomPrice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUomPrice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = pricelistSlice.actions;

export const selectData = (state) => state.pricelist.data;
export const selectDataDetail = (state) => state.pricelist.data3;
export const selectDataType = (state) => state.pricelist.data2;
export const selectId = (state) => state.pricelist.dataId;
export const selectLoading = (state) => state.pricelist.loading;
export const selectError = (state) => state.pricelist.error;
export const selectPageNo = (state) => state.pricelist.pageNo;
export const selectPageSize = (state) => state.pricelist.pageSize;
export const selectTotalRecord = (state) => state.pricelist.totalRecord;
export const selectSelected = (state) => state.pricelist.selected;
export const selectResult = (state) => state.pricelist.result;

export default pricelistSlice.reducer;
